export const colors = {
  primary: '#85bb65',
  white: '#fff',
  black: '#000',
  grey: '#e5e6f0',
};
